import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "HOME", href: "/" },
    { label: "INDUSTRIES", href: "/industries" },
    { label: "CASE STUDIES", href: "/case-studies" },
    { label: "CONTACT", href: "/contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black border-b border-[#FFD100]/20" : "bg-transparent"
      }`}
    >
      <div className="w-full px-8 md:px-16 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/e983ed97-798b-4c5c-b98b-62d7ac7ea8d5.png"
            alt="SOLAINVESTAI"
            className="w-[90px] h-[90px] object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-xs tracking-[3px] font-bold transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? "text-[#FFD100]"
                  : "text-white hover:text-[#FFD100]"
              }`}
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              {link.label}
            </Link>
          ))}

          {/* Day / Night Toggle */}
          <button
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            title={theme === "dark" ? "Switch to day mode" : "Switch to night mode"}
          >
            <span className="theme-toggle__knob">
              {theme === "dark" ? (
                <i className="ri-moon-fill" style={{ fontSize: "11px" }} />
              ) : (
                <i className="ri-sun-fill" style={{ fontSize: "11px" }} />
              )}
            </span>
          </button>

          <Link
            to="/contact"
            className="ml-2 bg-[#FFD100] text-black text-xs font-bold tracking-[2px] px-6 py-3 cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-white"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            BOOK AUDIT
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-black border-t border-[#FFD100]/20 px-8 py-6 flex flex-col gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className={`text-xs tracking-[3px] font-bold whitespace-nowrap ${
                location.pathname === link.href ? "text-[#FFD100]" : "text-white"
              }`}
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              {link.label}
            </Link>
          ))}

          {/* Day / Night Toggle — mobile */}
          <div className="flex items-center gap-4">
            <span
              className="text-white text-xs tracking-[2px] font-bold"
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              {theme === "dark" ? "NIGHT MODE" : "DAY MODE"}
            </span>
            <button
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label="Toggle theme"
            >
              <span className="theme-toggle__knob">
                {theme === "dark" ? (
                  <i className="ri-moon-fill" style={{ fontSize: "11px" }} />
                ) : (
                  <i className="ri-sun-fill" style={{ fontSize: "11px" }} />
                )}
              </span>
            </button>
          </div>

          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="bg-[#FFD100] text-black text-xs font-bold tracking-[2px] px-6 py-3 text-center whitespace-nowrap"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            BOOK AUDIT
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
